import { Helmet } from "react-helmet-async"
import { observer } from "mobx-react-lite"
import * as Yup from "yup"
import {
  TextInput,
  PasswordInput,
  Flex,
  Anchor,
  Paper,
  Title,
  Container,
  Group,
  Button,
  createStyles,
  Alert,
} from "@mantine/core"
import { useForm, yupResolver } from "@mantine/form"
import { IconAlertCircle } from "@tabler/icons-react"
import authScreen from "shared/assets/auth-screen.svg"
import React from "react"
import { AuthStore } from "../../app/store"

// ----------------------------------------------------------------------

const schema = Yup.object().shape({
  password: Yup.string().required("Пароль обязателен"),
  email: Yup.string().email("Неправильный формат адреса").required("Адрес обязателен"),
})

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  paper: {
    padding: "4rem",
    flex: 4,

    [theme.fn.smallerThan("md")]: {
      padding: "2.5rem",
    },

    [theme.fn.smallerThan("sm")]: {
      padding: "1.5rem",
      margin: "0 auto",
      maxWidth: 640,
    },

    [theme.fn.smallerThan("xs")]: {
      padding: "1rem",
    },
  },

  imageContainer: {
    display: "flex",
    alignItems: "stretch",
    borderRadius: theme.radius.xl,
    overflow: "hidden",
    flex: 3,

    [theme.fn.smallerThan("sm")]: {
      display: "none",
    },
  },

  image: {
    maxWidth: "100%",
    height: "auto",
    objectFit: "cover",
  },
}))

// ----------------------------------------------------------------------

export const LoginPage = observer(function LoginPage() {
  const { classes } = useStyles()

  const { login, isLoading, error } = AuthStore

  const form = useForm({
    initialValues: { email: "", password: "" },
    validate: yupResolver(schema),
  })

  const onSubmit = (values: typeof form.values) => void login(values)

  return (
    <>
      <Helmet>
        <title>BodyCoach - авторизация</title>
      </Helmet>

      <Container size="lg" my={64}>
        <Title align="center">Войдите в свой профиль</Title>
        <Flex mt={48} justify="space-between" gap="xl" align="flex-start">
          <Paper withBorder shadow="md" className={classes.paper} radius="lg">
            <form onSubmit={form.onSubmit(onSubmit)}>
              <TextInput
                {...form.getInputProps("email")}
                label="Электронная почта"
                placeholder="you@bodycoach.pro"
                size="lg"
                radius="md"
              />
              <PasswordInput
                {...form.getInputProps("password")}
                label="Пароль"
                placeholder="Ваш пароль"
                mt="xl"
                size="lg"
                radius="md"
              />
              <Group position="right" mt="lg">
                <Anchor component="button" size="sm">
                  Не помню пароль
                </Anchor>
              </Group>

              <Button loading={isLoading} type="submit" fullWidth mt="xl" size="lg" radius="md">
                Войти
              </Button>

              {error && (
                <Alert
                  radius="md"
                  mt="xl"
                  icon={<IconAlertCircle size="1rem"/>}
                  title="Ошибка авторизации"
                  color="red"
                >
                  {error}
                </Alert>
              )}
            </form>
          </Paper>
          <div className={classes.imageContainer}>
            <img src={authScreen} alt="Изображение авторизации" className={classes.image}/>
          </div>
        </Flex>
      </Container>
    </>
  )
})
